import React from "react";
import "./SpinnerOne.css";

export default function Spinnner1() {
  return (
    <div className="lds-roller">
      <section>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </section>
    </div>
  );
}
